const SEND_REMINDER = 'Send Reminder'
const PRESENT_TEMPLATE = 'Preset Template'
const REMINDER_SUBJECT = 'Reminder Subject'
const RECIPIENT = 'Recipient'
const MESSAGE = 'Message'
const CANCEL = 'Cancel'

export { SEND_REMINDER, PRESENT_TEMPLATE, REMINDER_SUBJECT, RECIPIENT, MESSAGE, CANCEL }
